import React from 'react';
import { Route } from 'react-router';
import { Link } from 'react-router-dom';
import Map from './Map/Municipal';
import { AreaListOrdered } from './AreaList';
import Title from '../Symbols/Title';

export default function Cities(props) {
	return <>
		<Title>
			Kdo ovládl velká města
			<Route
				path="/obec/"
				render={() => (
					<Link to="/" style={{ 'float': 'right', marginBottom: '10px' }}>Zpět na celkový přehled</Link>
				)}
			/>
		</Title>
		<Map cities={props.cities} />

		<AreaListOrdered type="obec" list={props.cities} />
	</>;
}

Cities.defaultProps = {
	// 30 largest cities in Czech republic
	cities: [
		{ name: 'Praha', cx: 147, cy: 97, id: 554782 },
		{ name: 'Brno', cx: 278, cy: 177, id: 582786 },
		{ name: 'Ostrava', cx: 377, cy: 117, id: 554821 },
		{ name: 'Plzeň', cx: 78, cy: 120, id: 554791 },
		{ name: 'Liberec', cx: 181, cy: 33, id: 563889 },
		{ name: 'Olomouc', cx: 314, cy: 141, id: 500496 },
		{ name: 'Ústí nad Labem', cx: 120, cy: 37, id: 554804 },
		{ name: 'Hradec Králové', cx: 229, cy: 85, id: 569810 },
		{ name: 'České Budějovice', cx: 150, cy: 200, id: 544256 },
		{ name: 'Pardubice', cx: 225, cy: 100, id: 555134 },

		{ name: 'Havířov', cx: 390, cy: 123, id: 555088 },
		{ name: 'Zlín', cx: 353, cy: 170, id: 585068 },
		{ name: 'Kladno', cx: 133, cy: 87, id: 532053 },
		{ name: 'Most', cx: 95, cy: 52, id: 567027 },
		{ name: 'Karviná', cx: 395, cy: 112, id: 598917 },
		{ name: 'Opava', cx: 355, cy: 105, id: 505927 },
		{ name: 'Frýdek-Místek', cx: 385, cy: 134, id: 598003 },
		{ name: 'Karlovy Vary', cx: 55, cy: 80, id: 554961 },
		{ name: 'Jihlava', cx: 215, cy: 160, id: 586846 },
		{ name: 'Teplice', cx: 107, cy: 42, id: 567442 },

		{ name: 'Děčín', cx: 133, cy: 30, id: 562335 },
		{ name: 'Chomutov', cx: 80, cy: 58, id: 562971 },
		{ name: 'Přerov', cx: 333, cy: 153, id: 511382 },
		{ name: 'Jablonec nad Nisou', cx: 191, cy: 40, id: 563510 },
		{ name: 'Mladá Boleslav', cx: 170, cy: 70, id: 535419 },
		{ name: 'Prostějov', cx: 304, cy: 150, id: 589250 },
		{ name: 'Třebíč', cx: 240, cy: 175, id: 590266 },
		{ name: 'Česká Lípa', cx: 150, cy: 35, id: 561380 },
		{ name: 'Třinec', cx: 407, cy: 130, id: 598810 },
		{ name: 'Tábor', cx: 155, cy: 160, id: 552046 },

		{ name: 'Znojmo', cx: 235, cy: 205, id: 593711 },
		{ name: 'Příbram', cx: 120, cy: 130, id: 539911 },
		{ name: 'Cheb', cx: 20, cy: 90, id: 554481 },
		{ name: 'Orlová', cx: 386, cy: 113, id: 599069 },
		{ name: 'Kolín', cx: 190, cy: 105, id: 533165 },
		{ name: 'Trutnov', cx: 232, cy: 52, id: 579025 },
		{ name: 'Písek', cx: 132, cy: 172, id: 549240 },
		{ name: 'Kroměříž', cx: 330, cy: 165, id: 588296 },
		{ name: 'Šumperk', cx: 295, cy: 110, id: 523704 },
		{ name: 'Vsetín', cx: 367, cy: 160, id: 541630 },

		{ name: 'Valašské Meziříčí', cx: 364, cy: 149, id: 545058 },
		{ name: 'Litvínov', cx: 93, cy: 40, id: 567256 },
		{ name: 'Uherské Hradiště', cx: 340, cy: 190, id: 592005 },
		{ name: 'Hodonín', cx: 307, cy: 207, id: 586021 },
		{ name: 'Český Těšín', cx: 400, cy: 121, id: 598933 },
		{ name: 'Břeclav', cx: 295, cy: 215, id: 584291 },
		{ name: 'Krnov', cx: 342, cy: 90, id: 597520 },
		{ name: 'Litoměřice', cx: 130, cy: 53, id: 564567 },
		{ name: 'Sokolov', cx: 39, cy: 85, id: 560286 },
		{ name: 'Nový Jičín', cx: 367, cy: 139, id: 599191 }
	]
}
